<template>
    <div class="roles box">
        <div class="insert-role">
            <h2>{{ t('places-roles-title') }}</h2>
            <div class="form">
                <input
                    type="text"
                    v-model="newRole"
                    class="form-control"
                    :placeholder="t('places-roles-new_role_placeholder')"
                    @keydown.enter="insert"
                />
            </div>
        </div>
        <table class="table table--list">
            <thead>
                <tr>
                    <th>{{ t('name') }}</th>
                    <th>{{ t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="role in roles" :key="role.id">
                    <template v-if="editRole.id === role.id">
                        <td>
                            <input
                                type="text"
                                class="form-control"
                                v-model="editRole.title"
                                @keydown.enter="saveRole()"
                            />
                        </td>
                        <td>
                            <button
                                class="btn btn-small btn-primary"
                                @click="saveRole()"
                            >
                                {{ t('save') }}
                            </button>
                        </td>
                    </template>
                    <template v-else>
                        <td>
                            {{ role.title }}
                        </td>
                        <td>
                            <button
                                class="btn btn-small btn-primary"
                                @click="editRole = role"
                            >
                                {{ t('edit') }}
                            </button>
                            <button
                                class="btn btn-small btn-warning"
                                @click="deleteRole(role)"
                            >
                                {{ t('delete') }}
                            </button>
                        </td>
                    </template>
                </tr>
            </tbody>
        </table>
        <div class="clear"></div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import keviApi from "../../../keviApi";
export default {
    computed: mapState({
        roles: (state) => state.placeDetails.roles,
        placeId: (state) => state.placeDetails.id,
    }),
    data: function () {
        return {
            newRole: null,
            editRole: {
                id: null,
                title: null,
            },
        };
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        insert() {
            let options = keviApi.getOptions(
                "place/" + this.placeId + "/roles",
                "put",
                {
                    title: this.newRole,
                },
            );
            this.$http(options).then((response) => {
                this.newRole = "";
                this.$store.dispatch("placeDetails/loadRoles");
                this.$store.dispatch(
                    "notification/success",
                    this.t('places-roles-role_added'),
                );
            });
        },
        saveRole() {
            let options = keviApi.getOptions(
                "place/" + this.placeId + "/role/" + this.editRole.id,
                "POST",
                {
                    title: this.editRole.title,
                },
            );
            this.$http(options).then(async (response) => {
                await this.$store.dispatch("placeDetails/loadRoles");
                this.$store.dispatch(
                    "notification/success",
                    this.t('places-roles-role_updated'),
                );
                this.editRole = {
                    id: null,
                    title: null,
                };
            });
        },
        deleteRole(role) {
            let options = keviApi.getOptions(
                "place/" + this.placeId + "/role/" + role.id,
                "DELETE",
            );
            this.$http(options).then(async (response) => {
                await this.$store.dispatch("placeDetails/loadRoles");
                this.$store.dispatch("notification/success", this.t('places-roles-role_deleted'));
            });
        },
    },
};
</script>
<style lang="less" scoped>
.insert-role {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
</style>
